import { createRouter, createWebHistory } from "vue-router";

// 导入组件
const Home = () => import("@/components/HelloWorld.vue");
const Pay = () => import("@/components/Pay.vue");

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/pay",
    name: "Pay",
    component: Pay,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
